import { render } from "./DownloadMenu.vue?vue&type=template&id=ae180410"
import script from "./DownloadMenu.vue?vue&type=script&lang=js"
export * from "./DownloadMenu.vue?vue&type=script&lang=js"

import "./DownloadMenu.vue?vue&type=style&index=0&id=ae180410&soped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__